(function () {
  var root = document.getElementById("beisat-side-menu");
  if (!root) return;
  if (root.parentElement !== document.body) document.body.appendChild(root);

  var drawer = root.querySelector(".bsm");
  var scrim = root.querySelector(".bsm-scrim");
  var viewport = root.querySelector(".bsm-viewport");
  var langBtn = root.querySelector("[data-bsm-lang-btn]");
  var langDrop = root.querySelector("[data-bsm-lang-drop]");
  var stack = ["root"];
  var opener = null;

  function isMobile() {
    return window.matchMedia("(max-width: 767.98px)").matches;
  }

  // Department panels ship in a <template>; add them the first time they are needed.
  function hydratePanels() {
    var tpl = viewport.querySelector("template[data-bsm-deferred]");
    if (!tpl) return;
    viewport.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
  }

  function panel(id) {
    if (id !== "root") hydratePanels();
    return viewport.querySelector('[data-bsm-panel="' + id + '"]');
  }

  function show(id, push) {
    var next = panel(id);
    if (!next) return;
    var current = viewport.querySelector(".bsm-panel.is-active");
    if (current === next) return;

    next.setAttribute("aria-hidden", "false");
    next.classList.remove("is-old");
    window.requestAnimationFrame(function () {
      next.classList.add("is-active");
    });

    if (current) {
      current.classList.remove("is-active");
      current.classList.add("is-old");
      current.setAttribute("aria-hidden", "true");
      window.setTimeout(function () {
        if (!current.classList.contains("is-active")) current.classList.remove("is-old");
      }, 270);
    }

    if (push) stack.push(id);
    next.scrollTop = 0;
    closeDrops();
  }

  function goBack() {
    if (stack.length <= 1) {
      show("root", false);
      stack = ["root"];
      return;
    }
    stack.pop();
    show(stack[stack.length - 1], false);
  }

  function resetToRoot() {
    stack = ["root"];
    viewport.querySelectorAll(".bsm-panel").forEach(function (el) {
      var isRoot = el.getAttribute("data-bsm-panel") === "root";
      el.classList.toggle("is-active", isRoot);
      el.classList.remove("is-old");
      el.setAttribute("aria-hidden", isRoot ? "false" : "true");
    });
  }

  function openMenu(from) {
    hydratePanels();
    opener = from || document.querySelector(".logo-area .mobile-nav-toggle");
    drawer.classList.add("is-open");
    scrim.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("bsm-open");
    document.documentElement.style.overflow = "hidden";
    if (opener) opener.setAttribute("aria-expanded", "true");
    var closeBtn = drawer.querySelector(".bsm-close");
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    drawer.classList.remove("is-open");
    scrim.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bsm-open");
    document.documentElement.style.overflow = "";
    closeDrops();
    if (opener) {
      opener.setAttribute("aria-expanded", "false");
      opener.focus();
    }
    window.setTimeout(resetToRoot, 280);
  }

  function closeDrops() {
    if (langDrop) langDrop.classList.remove("is-open");
    if (langBtn) {
      langBtn.classList.remove("is-open");
      langBtn.setAttribute("aria-expanded", "false");
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var toggle = event.target.closest && event.target.closest(".mobile-nav-toggle");
      if (!toggle || !isMobile()) return;
      if (toggle.closest(".mobile-navigation-drawer") || toggle.closest("#beisat-side-menu")) return;
      event.preventDefault();
      event.stopPropagation();
      if (toggle.classList.contains("header-shade") || drawer.classList.contains("is-open")) {
        closeMenu();
        return;
      }
      openMenu(toggle);
    },
    true
  );

  root.addEventListener("click", function (event) {
    if (event.target.closest("[data-bsm-close]")) {
      event.preventDefault();
      closeMenu();
      return;
    }

    var go = event.target.closest("[data-bsm-go]");
    if (go) {
      event.preventDefault();
      show(go.getAttribute("data-bsm-go"), true);
      return;
    }

    if (event.target.closest("[data-bsm-back]")) {
      event.preventDefault();
      goBack();
      return;
    }

    var localeBtn = event.target.closest("[data-bsm-locale]");
    if (localeBtn) {
      var form = root.querySelector("form.bsm-locale");
      var input = form && form.querySelector('input[name="locale_code"]');
      if (input && form) {
        input.value = localeBtn.getAttribute("data-bsm-locale");
        form.submit();
      }
      return;
    }

    if (!event.target.closest(".bsm-select")) closeDrops();
  });

  if (langBtn) {
    langBtn.addEventListener("click", function (event) {
      event.stopPropagation();
      var open = langDrop.classList.contains("is-open");
      closeDrops();
      if (!open) {
        langDrop.classList.add("is-open");
        langBtn.classList.add("is-open");
        langBtn.setAttribute("aria-expanded", "true");
      }
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && drawer.classList.contains("is-open")) closeMenu();
  });

  window.addEventListener("resize", function () {
    if (!isMobile() && drawer.classList.contains("is-open")) closeMenu();
  });
})();
